import { render, staticRenderFns } from "./Page023.vue?vue&type=template&id=20f28a13&scoped=true&"
import script from "./Page023.vue?vue&type=script&lang=js&"
export * from "./Page023.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f28a13",
  null
  
)

export default component.exports